import './Login.css';
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import authService from '../../services/AuthService';

/**
 * ConsumerLoginRedirect handles the redirect to Cognito for the CADEY app authentication.
 * ab - I do not think this is not in use anymore for just the CADE/Corbett codebase
 *
 * This component builds the Cognito login URL using environment variables:
 * - REACT_APP_CADEY_COGNITO_CLIENT_ID: CADEY Cognito App Client ID (the Cognito user pool app ID)
 * - REACT_APP_CADEY_COGNITO_DOMAIN: CADEY Cognito hosted UI domain (the Cognito user pool domain )
 * - REACT_APP_CADEY_COGNITO_REDIRECT_URI: The BE URI to redirect the Consumer to
 *
 * It redirects the user to the Cognito hosted login page with a properly constructed
 * OAuth2 login URL, including the access token response type and basic scopes.
 * 
 * From the old code:
 * redirectUrl = 'https://production-cadey-cade.auth.us-west-2.amazoncognito.com/login?client_id=1jjtmf5m6d3cmfcbumtq8pjni2&response_type=token&scope=aws.cognito.signin.user.admin+openid+email+profile&redirect_uri=https://clear-cade.com/consumerredirect';
 * redirectUrl = 'https://staging-consumer-cade.auth.us-west-2.amazoncognito.com/login?client_id=6f3vtj1tsj9ed9fdiue0dfai5i&response_type=token&scope=aws.cognito.signin.user.admin+openid+email+profile&redirect_uri=https://web-stage.clear-cade.com/consumerredirect'
 * redirectUrl = 'https://localhost-cadey-cade.auth.us-west-2.amazoncognito.com/login?client_id=5ljs22k76chbjmn8oql7bj9e3l&response_type=token&scope=aws.cognito.signin.user.admin+openid+email+profile&redirect_uri=https://localhost:5001/consumerredirect'
 */

export class ConsumerLogin extends Component {

    constructor(props) {
        super(props);

        this.state = {
            helpMessage: null,
            userName: null,
            password: null, 
            firstPage: null
        };

        authService.clearAuthenticated();
    }

    render() {
        // Redirect if already authenticated
        if (authService.isAuthenticated) {
            return <Redirect to={this.state.firstPage} />;
        }

        // Clear any existing session state
        authService.clearAuthenticated();

        // Load required values from environment
        const clientId = process.env.REACT_APP_CADEY_COGNITO_CLIENT_ID;
        const domain = process.env.REACT_APP_CADEY_COGNITO_DOMAIN;
        const redirectUri = process.env.REACT_APP_CADEY_COGNITO_REDIRECT_URI;

        // OAuth2 parameters
        const responseType = 'token';
        const scope = 'aws.cognito.signin.user.admin openid email profile';

        // Build full Cognito login URL
        const loginUrl = `${domain}/login?client_id=${clientId}&response_type=${responseType}&scope=${encodeURIComponent(scope)}&redirect_uri=${encodeURIComponent(redirectUri)}`;

        // Redirect to Cognito login
        window.location.href = loginUrl;
    }
}

export default ConsumerLogin;




// WEBPACK FOOTER //
// ./src/components/Login/ConsumerLogin.js